import indexer, { IListObj, jwtToken } from "./../../types/genericTypes";
import { parsedToken } from "../../service/storageHelper";
import DeviceContext from "../../service/indentifyDevice";
import { CSSProperties, useState } from "react";
const hndlDevice = DeviceContext();
export default function FTSecNavOptions(): Array<IListObj> {
	let pToken: jwtToken | null = parsedToken();
	let ftUrls: Array<IListObj> = [
		{ value: "add-funds", display: "Add funds", href: "/fund-transfer/add-funds" },
		{ value: "withdraw-funds", display: "Withdraw", href: "/fund-transfer/withdraw-funds" }
	];
	if (pToken) {
		if (pToken.accType !== "CO") {
			ftUrls.push({
				value: "historyeq",
				display: pToken.accType !== "COMEQ" ? "History" : hndlDevice.isDesktop ? "Equity - History" : "Eq - History",
				href: "/fund-transfer/history/eq/added"
			});
		}
		if (pToken.accType !== "EQ") {
			ftUrls.push({
				value: "historyco",
				display: pToken.accType !== "COMEQ" ? "History" : hndlDevice.isDesktop ? "Commodity - History" : "Com - History",
				href: "/fund-transfer/history/co/added"
			});
		}
	}
	return ftUrls;
}

export const ftHelpDetails = {
	email: "helpdesk@nuvama.com",
	tel: "1800 102 3335",
	timings: "8am - 5.30pm",
	payoutMsg:
		"Payout requests placed till 3:30 PM on trading days will be processed on same day. Payout requests placed after 3:30 PM will be processed on next trading day. In case of Bank holidays the requests will be processed on next bank working day excluding Saturdays."
};

export const FTChipColorKeyComb: indexer = {
	"request sent": "blue",
	failed: "red",
	"in process": "blue",
	inprocess: "blue",
	processed: "green",
	cancelled: "red",
	"payout pending": "blue",
	pending: "blue",
	"upi int failed": "red"
};

//custom hook to compute max height based on the api response data
export const FTScrollStyle = (setMinMax: boolean): CSSProperties => {
	const [computedStyles, setcomputedStyles] = useState<CSSProperties>({});
	const ele = document.querySelector("body") as HTMLElement;
	//on rough guess this offset has been set - should be changed to accurate values
	const offset: string = DeviceContext().isMobile ? "120px" : "260px";
	if (setMinMax) {
		setTimeout(() => {
			if (ele.scrollHeight > window.innerHeight) {
				setcomputedStyles({
					height: "calc(" + window.innerHeight + "px - " + offset + ")",
					overflowY: "auto",
					marginLeft: !DeviceContext().isMobile ? "-10px" : "0"
				});
			}
		}, 350);
	}

	return computedStyles;
};
export const FTRegex: indexer = {
	amt: "^[0-9]{0,10}[.]?[0-9]{0,2}$",
	mobAmt: "[0-9]*",
	upi: "^[a-zA-Z0-9.@_-]*$"
};
